import { z } from "zod";
import { IsoDateTime, jsonColumn } from "./common.ts";

const RecordingMbidSchema = z.string().uuid();

export const AB_FETCH_STATUSES = ["ok", "partial", "not_found", "failed"] as const;
export const AbFetchStatusSchema = z.enum(AB_FETCH_STATUSES);
export type AbFetchStatus = z.infer<typeof AbFetchStatusSchema>;

export const AbMoodSchema = z.object({
  id: z.string(),
  label: z.string(),
  value: z.string(),
  probability: z.number(),
});
export type AbMood = z.infer<typeof AbMoodSchema>;

export const AbGenreSchema = z.object({
  model: z.string(),
  value: z.string(),
  probability: z.number(),
});
export type AbGenre = z.infer<typeof AbGenreSchema>;

/** Parsed surface fields we care about in the Enrich UI. */
export const AbParsedSchema = z.object({
  bpm: z.number().nullable(),
  key: z.string().nullable(),
  scale: z.string().nullable(),
  moods: z.array(AbMoodSchema),
  genres: z.array(AbGenreSchema),
});
export type AbParsed = z.infer<typeof AbParsedSchema>;

export const AbEntitySchema = z.object({
  recording_mbid: RecordingMbidSchema,
  low_level_json: jsonColumn(z.unknown().nullable()),
  high_level_json: jsonColumn(z.unknown().nullable()),
  parsed: jsonColumn(AbParsedSchema),
  fetch_status: AbFetchStatusSchema,
  fetched_at: IsoDateTime,
  error: z.string().nullable(),
});
export type AbEntity = z.infer<typeof AbEntitySchema>;

export const AbRunStatsSchema = z.object({
  fetched: z.number().int().nonnegative(),
  found: z.number().int().nonnegative(),
  not_found: z.number().int().nonnegative(),
  failed: z.number().int().nonnegative(),
});
export type AbRunStats = z.infer<typeof AbRunStatsSchema>;
